<!-- 组件说明 -->
<template>
  <div class>
    <van-tabs>
      <van-tab v-for="index in 8" :title="'标签 ' + index" :key="index">
        <div style="height:100rem; background:red"></div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
//import x from ''
import goods from '@/api/goods';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
    //生命周期 - 创建完成
    goods.listForTag({ tagId: 2 });
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/Test.vue